module.exports = __webpack_public_path__ + "static/img/laila.9dc0d3fa.png";